<template>
  <fieldset class="tab tab-06">
    <div class="heading-form a-center">
      <span class="number">6/11</span>
      <p class="c-yellow">ไลฟ์สไตล์ของคุณ</p>
      <h2 class="heading-h2 c-white">
        กิจกรรมยามว่างของคุณ<span class="br767">มีอะไรบ้าง</span>
      </h2>
      <p class="desc">(เลือกได้มากกว่า 1 ข้อ)</p>
    </div>
    <div class="icw-fieldset-inner">
      <ul class="icw-fields">
        <li class="icw-field icw-field-full">
          <div
            class="icw-input icw-input-checkbox icon-none icw-input-full c-lifestyle"
          >
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle"
                id="readbook"
                class="css-checkbox"
                value="readbook"
                v-model="lifestyles"
              />
              <label for="readbook" class="css-label"
                ><i class="ic ic-book"></i>อ่านหนังสือ</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle"
                id="music"
                class="css-checkbox"
                value="music"
                v-model="lifestyles"
              />
              <label for="music" class="css-label"
                ><i class="ic ic-music"></i>ฟังเพลง</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle"
                id="game"
                class="css-checkbox"
                value="game"
                v-model="lifestyles"
              />
              <label for="game" class="css-label"
                ><i class="ic ic-game"></i>เล่นเกม</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle"
                id="social"
                class="css-checkbox"
                value="social"
                v-model="lifestyles"
              />
              <label for="social" class="css-label"
                ><i class="ic ic-social"></i>เล่นโซเชียลมีเดีย</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle"
                id="movie"
                class="css-checkbox"
                value="movie"
                v-model="lifestyles"
              />
              <label for="movie" class="css-label"
                ><i class="ic ic-movie"></i>ดูภาพยนตร์</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle"
                id="concert"
                class="css-checkbox"
                value="concert"
                v-model="lifestyles"
              />
              <label for="concert" class="css-label"
                ><i class="ic ic-concert"></i>ดูคอนเสิร์ต</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle"
                id="theater"
                class="css-checkbox"
                value="theater"
                v-model="lifestyles"
              />
              <label for="theater" class="css-label"
                ><i class="ic ic-stage"></i>ดูละครเวที</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle"
                id="shopping"
                class="css-checkbox"
                value="shoping"
                v-model="lifestyles"
              />
              <label for="shopping" class="css-label"
                ><i class="ic ic-shopping"></i>ช้อปปิ้งที่ห้าง / ร้านค้า</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle"
                id="shoppingonline"
                class="css-checkbox"
                value="shoppingonline"
                v-model="lifestyles"
              />
              <label for="shoppingonline" class="css-label"
                ><i class="ic ic-shopping-online"></i>ช้อปปิ้งออนไลน์</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle"
                id="travelin"
                class="css-checkbox"
                value="travelin"
                v-model="lifestyles"
              />
              <label for="travelin" class="css-label"
                ><i class="ic ic-travel"></i>เที่ยวในประเทศ</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle"
                id="travelout"
                class="css-checkbox"
                value="travelout"
                v-model="lifestyles"
              />
              <label for="travelout" class="css-label"
                ><i class="ic ic-trip"></i>เที่ยวต่างประเทศ</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle"
                id="beauty"
                class="css-checkbox"
                value="beauty"
                v-model="lifestyles"
              />
              <label for="beauty" class="css-label"
                ><i class="ic ic-make-up"></i>เสริมความงาม</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle"
                id="otherlifestyle"
                class="css-checkbox lifestyleEtc"
                value="etc"
                v-model="lifestyles"
              />
              <label for="otherlifestyle" class="css-label"
                ><i class="ic ic-other"></i
                >{{ lifestyles_etc == "" ? "อื่นๆ" : lifestyles_etc }}</label
              >
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="icw-fieldset-action previous">
      <button
        type="button"
        class="btn btn-previous previous"
        @click="prevStep('tab-06', 'tab-05')"
      >
        ย้อนกลับ
      </button>
    </div>
    <button
      type="button"
      id="btnNextStepQ7"
      class="btn btn-next next"
      :class="{ 'btn-disabled': !isPass }"
      @click="beforeNextStep()"
    >
      ถัดไป
    </button>

    <a
      href="#popup-input-lifestyle"
      class="popup-input-lifestyle"
      style="display: none;"
      >click me</a
    >
    <div id="popup-input-lifestyle" class="mfp-hide modal-input">
      <div class="modal-content">
        <div class="tb">
          <div class="tbcell v-middle">
            <div class="icw-form">
              <fieldset>
                <div>
                  <h3 class="heading-h3">กิจกรรมอื่นๆ</h3>
                </div>
                <div class="icw-fieldset-inner">
                  <ul class="icw-fields">
                    <li class="icw-field icw-field-full">
                      <div class="icw-input a-left">
                        <input
                          type="text"
                          id="txtHobbiesEtc"
                          placeholder="โปรดระบุ"
                          name="lifestyle_etc"
                          v-model="lifestyles_etc"
                          maxlength="100"
                        />
                      </div>
                    </li>
                    <li class="icw-field icw-field-full">
                      <div class="icw-input a-center">
                        <button
                          type="button"
                          id="btnHobbiesSubmitEtc"
                          class="btn"
                          @click="ConfJobText()"
                        >
                          ตกลง
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
import Vue from "vue";

/* jQuery */
import jQuery from "jquery";
/* jQuery */

import {
  my_storage,
  arr_unique,
  incCurrentStep
} from "@/helpers/global_helper.js";
import { nextStep, prevStep } from "@/helpers/step_helper.js";
window.jQuery = window.$ = jQuery;
require("@/assets/theme/plugin/magnific-popup/jquery.magnific-popup.js");

export default {
  name: "QuestionStep1_Q6",
  props: {
    QuestionType: String
  },
  mounted() {
    this.$nextTick(() => {
      $(".popup-input-lifestyle").magnificPopup({
        type: "inline",
        midClick: true,
        removalDelay: 150,
        mainClass: "mfp-fade",
        fixedContentPos: true
      });

      $(".lifestyleEtc").click(function() {
        $(".popup-input-lifestyle").trigger("click");
      });

      let self = this;

      $(".popup-input-lifestyle").on("mfpClose", function() {
        if ($("*[type=text][name=lifestyle_etc]").val() == "") {
          // $('.lifestyleEtc').trigger('click')
          self.lifestyles.splice(self.lifestyles.indexOf("etc"), 1);
          $(".lifestyleEtc").prop("checked", false);
        } else {
          // $('.lifestyleEtc').trigger('click')
          if (self.lifestyles.indexOf("etc") == -1) {
            self.lifestyles.push("etc");
          }
          $(".lifestyleEtc").prop("checked", true);
        }
      });
    });
  },
  data() {
    return {
      lifestyles:
        my_storage(this.QuestionType, "lifestyles") == ""
          ? []
          : my_storage(this.QuestionType, "lifestyles"),
      lifestyles_etc: my_storage(this.QuestionType, "lifestyles_etc")
    };
  },
  methods: {
    my_storage,
    nextStep,
    prevStep,
    beforeNextStep() {
      let pass = false;
      if (this.lifestyles.length > 0) {
        if (
          this.lifestyles.indexOf("etc") >= 0 &&
          this.lifestyles_etc.trim() != ""
        ) {
          pass = true;
        } else if (this.lifestyles.indexOf("etc") == -1) {
          pass = true;
        }
      }

      if (pass) {
        if (
          this.lifestyles_etc.trim() != "" &&
          this.lifestyles.indexOf("etc") == -1
        ) { this.lifestyles.push("etc"); }
        sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data));

        let currentTag = this.$vnode.componentOptions.tag;
        currentTag = currentTag.replace("Q", "");
        incCurrentStep("step1", currentTag);

        this.isError = false;

        this.nextStep("tab-06", "tab-07");
      } else {
        this.isError = true;
      }
    },
    ConfJobText() {
      if (this.lifestyles_etc.trim() != "") {
        $.magnificPopup.close();
      }
    }
  },
  watch: {
    lifestyles: function(n, o) {
      //   console.log( n );
    }
  },
  computed: {
    isPass() {
      let pass = false;
      if (this.lifestyles.length > 0) {
        if (
          this.lifestyles.indexOf("etc") >= 0 &&
          this.lifestyles_etc.trim() != ""
        ) {
          pass = true;
        } else if (this.lifestyles.indexOf("etc") == -1) {
          pass = true;
        }
      } else {
        pass = false;
      }
      return pass;
    }
  }
};
</script>
